import Vue from "vue";

/*
  Shared, reactive "is this a desktop-sized screen" flag. Questions render
  differently on desktop (checkbox lists, real tables) and the page stops
  auto-scrolling, which only helps on a phone.
*/
const DESKTOP_QUERY = "(min-width: 768px)";

const media =
    typeof window !== "undefined" && window.matchMedia
        ? window.matchMedia(DESKTOP_QUERY)
        : null;

const viewport = Vue.observable({
    desktop: media ? media.matches : false,
});

if (media) {
    const update = (event) => {
        viewport.desktop = event.matches;
    };
    if (media.addEventListener) {
        media.addEventListener("change", update);
    } else if (media.addListener) {
        media.addListener(update);
    }
}

export default viewport;
